import styled from 'styled-components';
import StyledButton from './StyledButton';

const StyledSendButton = styled(StyledButton)`
    
`;

export default StyledSendButton;